<template>
    <div class="layout default">
        <nav class="header">
            <app-header/>
        </nav>

        <main class="content">
            <slot/>
        </main>

        <footer class="footer">
            <app-footer/>
        </footer>

        <CookieAcceptDecline/>
    </div>
</template>

<script>
// Cookies
import CookieAcceptDecline from '../components/Cookies/CookieAcceptDecline';

import AppHeader from "../components/Header/Header";
import AppFooter from "../components/Footer";
import Splash from "../views/Splash";
import UserBannedModalHandler from "../components/UserBannedModalHandler";

export default {
  components: {
    UserBannedModalHandler,
    AppHeader,
    AppFooter,
    Splash,
    CookieAcceptDecline
  },
};
</script>

<style scoped lang="scss">
@import "./../styles/variables";
.container {
  max-width: 960px;
}
</style>

<style lang="scss">
@import "./../styles/variables";

.container {
  max-width: 960px;
  .top {
    background: var(--pallete_dark_color);
  }
}
</style>
